import { useAppDispatch } from '@/hooks';
import { useLogout } from '@/hooks/useLogout';
import { useUserInfo } from '@/hooks/useUserInfo';
import { setChipsModalOpen } from '@/store/slices/uiSlice';
import toast from 'react-hot-toast';
import {
  FaUserTie,
  FaHandHoldingUsd,
  FaScroll,
  FaFileInvoice,
  FaReceipt,
  FaUserPlus,
  FaCog,
  FaPowerOff,
} from 'react-icons/fa';
import { GiReceiveMoney } from 'react-icons/gi';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';

const tabs = [
  { name: 'Profile', icon: FaUserTie, path: '/profile' },
  { name: 'Deposit', icon: FaHandHoldingUsd, path: '/deposit' },
  { name: 'Withdraw', icon: FaScroll, path: '/withdraw' },
  { name: 'Deposit Report', icon: FaHandHoldingUsd, path: '/deposit-report' },
  { name: 'Withdraw Report', icon: FaScroll, path: '/withdraw-report' },
  { name: 'Account Statement', icon: FaFileInvoice, path: '/account-statement' },
  { name: 'Bonus Report', icon: GiReceiveMoney, path: '/bonus-report' },
  { name: 'P/L Report', icon: FaReceipt, path: '/pl-report' },
  { name: 'My Referrals', icon: FaUserPlus, path: '/referrals' },
];

const ScrollTabs = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { handleLogout, isLoading } = useLogout();
  const { isDemoAccount, loggedIn } = useUserInfo();

  const allItems = [
    ...tabs.map((tab) => ({
      key: tab.path,
      icon: tab.icon,
      label: tab.name,
      onClick: () => navigate(tab.path),
      isActive: window.location.pathname === tab.path,
    })),
    {
      key: 'chip-settings',
      icon: FaCog,
      label: 'Chip Settings',
      onClick: () => {
        if (!loggedIn || isDemoAccount) {
          toast.error('PleaseLOGIN OR REGISTER From Real User');
          return;
        }
        dispatch(setChipsModalOpen(true));
      },
      isActive: false,
    },
    {
      key: 'logout',
      icon: FaPowerOff,
      label: 'Logout',
      onClick: handleLogout,
      isActive: false,
    },
  ];

  return (
    <div className="w-full bg-primary-dark mb-3">
      <Swiper
        modules={[FreeMode]}
        freeMode={{
          enabled: true,
          sticky: false,
          momentumRatio: 0.5,
          momentumVelocityRatio: 0.5,
        }}
        slidesPerView="auto"
        spaceBetween={8}
        grabCursor={true}
        className="!px-2 !py-2"
      >
        {allItems.map((item) => {
          const Icon = item.icon;

          return (
            <SwiperSlide key={item.key} className="!w-auto">
              <button
                onClick={item.onClick}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm whitespace-nowrap transition
                  ${
                    item.isActive
                      ? 'bg-primary text-white'
                      : 'bg-secondary hover:bg-primary/20 text-gray-300'
                  }`}
              >
                <span className="p-1 bg-primary/80 rounded">
                  <Icon size={14} />
                </span>
                <span className={`font-semibold ${item.isActive ? 'text-black' : 'text-white'}`}>
                  {item.label}
                </span>
              </button>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ScrollTabs;
